import axios from 'axios'

export const login = (info) => {
  return axios.post('/login', info)
}

export const changePassword = (data) => {
  return axios.put('account/change-password', data)
}

export const getPersonlInformation = () => {
  return axios.get('account')
}



// WEBPACK FOOTER //
// ./src/api/accounts.js